__webpack_require__.p = "/fusigi_na_shooting/";